"use client";

import { cn } from "@repo/design-system/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function AuthTabs() {
	const pathname = usePathname();
	const isSignUp = pathname?.startsWith("/sign-up") ?? false;

	const tabClass = (active: boolean) =>
		cn(
			"rounded-[7px] border px-5 py-2 text-sm transition",
			active
				? "border-[#E6E1D2] bg-white font-semibold text-[#1A2314] shadow-[0_1px_2px_rgba(16,24,40,0.12)]"
				: "border-transparent font-medium text-[#1A2314] hover:text-[#1A2314]/70",
		);

	return (
		<div className="inline-flex items-center gap-1 rounded-[10px] border border-[#E2DBCB] bg-[#EFEAE0] p-1">
			<Link href="/sign-up" className={tabClass(isSignUp)}>
				Sign up
			</Link>
			<Link href="/sign-in" className={tabClass(!isSignUp)}>
				Log in
			</Link>
		</div>
	);
}
